import React from 'react';
import { Provider } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Header, Footer } from '../components/index';
import Navigation from '../navigation/navigation';
import { appStore } from '../redux-saga/store';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Provider store={appStore}>
        <React.Fragment>
          <Header />
          <Navigation />
          <Footer />
        </React.Fragment>
      </Provider>
    );
  }
}

export default withTranslation()(App);
